<template>
    <div class="hospitalList">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap" v-loading="loading">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">订单详情</span>
            </div>
            <div class="detail-info-wrap">
                <div class="detail-title">
                    <span class="title-text">基本信息</span>
                </div>
                <div class="detail-content">
                    <div class="detail-item-wrap">
                        <div class="detail-item">
                            <span class="label">订单编号:</span>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="short-popper"
                                        v-if="orderDetail.orderId"
                                        :disabled="orderDetail.orderId&&orderDetail.orderId.length < 23? true: false">
                                <span slot="content">
                                    {{orderDetail.orderId}}
                                </span>
                                <span class="text text-hidden">
                                    {{orderDetail.orderId}}
                                </span>
                            </el-tooltip>
                            <span class="text text-hidden"
                                  v-else>暂无</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">交易流水号:</span>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="short-popper"
                                        v-if="orderDetail.transactionId"
                                        :disabled="orderDetail.transactionId&&orderDetail.transactionId.length < 23? true: false">
                                <span slot="content">
                                    {{orderDetail.transactionId}}
                                </span>
                                <span class="text text-hidden">
                                    {{orderDetail.transactionId}}
                                </span>
                            </el-tooltip>
                            <span class="text text-hidden"
                                  v-else>暂无</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">支付时间:</span>
                            <span class="text">{{orderDetail.payTime|getDate}}</span>
                        </div>
                    </div>
                    <div class="detail-item-wrap">
                        <div class="detail-item">
                            <span class="label">订单费用(元):</span>
                            <span class="text">{{orderDetail.orderFee}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">订单类型:</span>
                            <span class="text">
                                {{typeList.find(type =>type.dictDataCode == orderDetail.orderType)
                                ? typeList.find(type =>type.dictDataCode == orderDetail.orderType).dictDataValue
                                : '暂无'}}
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="label">订单状态:</span>
                            <span class="text">
                                {{statusList.find(type =>type.dictDataCode == orderDetail.orderStatus)
                                ? statusList.find(type =>type.dictDataCode == orderDetail.orderStatus).dictDataValue
                                : '暂无'}}
                            </span>
                        </div>
                    </div>
                    <div class="detail-item-wrap" v-if="activeName === 'INCOME'">
                        <div class="detail-item">
                            <span class="label">优惠金额(元):</span>
                            <span class="text">{{orderDetail.discountFee || 0}}</span>
                        </div>
                        <div class="detail-item" >
                            <span class="label">订单来源:</span>
                            <span class="text">{{orderDetail.sourceTag|getScoreTag(consultFrom)}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">优惠:</span>
                            <span class="text">{{orderDetail.discountTag || '暂无'}}</span>
                        </div>
                    </div>
                    <div class="detail-item-wrap" v-if="activeName === 'INCOME'">
                        <div class="detail-item" >
                            <span class="label">收入金额(元):</span>
                            <span class="text">{{orderDetail.divideFee || 0}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">订单退款(元):</span>
                            <span class="text">{{orderDetail.refundFee || 0}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">退款时间:</span>
                            <span class="text">{{orderDetail.refundTime|getDate}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-info-wrap">
                <div class="detail-title">
                    <span class="title-text">用户信息</span>
                </div>
                <div class="detail-content">
                    <div class="detail-item-wrap">
                        <div class="detail-item">
                            <span class="label">用户姓名:</span>
                            <span class="text">{{orderDetail.userName||'暂无'}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">手机号:</span>
                            <span class="text">{{orderDetail.userPhone||'暂无'}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">用户来源:</span>
                            <span class="text">
                                {{originList.find(origin =>origin.dictDataCode == orderDetail.userSource)
                                ? originList.find(origin =>origin.dictDataCode == orderDetail.userSource).dictDataValue
                                : '暂无'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-info-wrap">
                <div class="detail-title">
                    <span class="title-text">订单信息</span>
                </div>
                <div class="detail-content" v-if="orderDetail.orderType === 'EXPERT_SEMINAR'">
                    <div class="detail-item-wrap">
                        <div class="detail-item">
                            <span class="label">课程名称:</span>
                            <span class="text">{{orderDetail.productName||'暂无'}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">来源医生:</span>
                            <span class="text">
                                {{orderDetail.doctorName||'暂无'}}{{orderDetail.docotrProfessionalTitle?' | '+orderDetail.docotrProfessionalTitle:''}}
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="label">科室:</span>
                            <span class="text">
                                {{orderDetail.deptName||'暂无'}}
                            </span>
                        </div>
                    </div>
                    <div class="detail-item-wrap">
                        <div class="detail-item">
                            <span class="label">医院:</span>
                            <span class="text">{{orderDetail.hospitalName||'暂无'}}</span>
                        </div>
                    </div>
                </div>
                <div class="detail-content" v-else>
                    <div class="detail-item-wrap">
                        <div class="detail-item">
                            <span class="label">患者姓名:</span>
                            <span class="text">{{orderDetail.patientName||'暂无'}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label" v-if="orderDetail.orderType === 'DISPENSING'">处方医生:</span>
                            <span class="label" v-else-if="orderDetail.orderType === 'CONSULTATION'">发起医生:</span>
                            <span class="label" v-else>接诊医生:</span>
                            <span class="text">{{orderDetail.userName||'暂无'}}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">科室:</span>
                            <span class="text">
                                {{orderDetail.deptName||'暂无'}}
                            </span>
                        </div>
                    </div>
                    <div class="detail-item-wrap">
                        <div class="detail-item">
                            <span class="label">医院:</span>
                            <span class="text">{{orderDetail.hospitalName||'暂无'}}</span>
                        </div>
                        <div class="detail-item" v-if="orderDetail.orderType === 'CONSULTATION'">
                            <span class="label">会诊医生:</span>
                            <span class="text">{{orderDetail.doctorName||'暂无'}}</span>
                        </div>
                        <div class="detail-item" v-if="orderDetail.orderType === 'DISPENSING'">
                            <span class="label">处方服务价格(元):</span>
                            <span class="text">{{orderDetail.serviceCostFee||'暂无'}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-info-wrap detail-fapiao-wrap">
                <div class="detail-title">
                    <span class="title-text">发票信息</span>
                </div>
                <div class="detail-content">
                    <div class="detail-item-wrap">
                        <div class="detail-item detail-receipt">
                            <span class="label">发票号:</span>
                            <span class="text-number" v-if="orderDetail.invoiceNumber">{{orderDetail.invoiceNumber}}</span>
                            <span class="add-receipt" @click="editNumber">{{orderDetail.invoiceNumber?'编辑':'添加'}}</span>
                            <!-- <span class="text">{{orderDetail.userName||'暂无'}}</span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="orderDetail.invoiceNumber?'编辑发票号':'添加发票号'"
                   :visible.sync="isEditShow"
                   custom-class="group-dialog-detail"
                   width="400px">
            <el-form :model="groupForm"
                     label-width="70px"
                     class="form-wrap"
                     ref="groupForm">
                <el-form-item label="发票号"
                              prop="invoiceNumber">
                    <el-input v-model.trim="groupForm.invoiceNumber"
                              placeholder="请输入"
                              :style="{width: '250px'}"
                              maxlength="12"
                              size="small"></el-input>
                </el-form-item>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="saveForm()">保 存</el-button>
                    <el-button size="small"
                               type="info"
                               plain
                               @click="cancelForm()">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 10px;
    height: 16px;
    line-height: 16px;
    border-bottom: 1px solid $border;
    margin-bottom: 20px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.detail-info-wrap {
    border-bottom: 1px solid $border;
    margin-bottom: 20px;
    .detail-title {
        padding-bottom: 20px;
    }
    .title-text {
        display: inline-block;
        font-size: 14px;
        color: #333;
        height: 16px;
        line-height: 16px;
        padding-left: 10px;
        border-left: 4px solid $color-primary;
    }
}
.detail-fapiao-wrap {
    border-bottom: none;
    margin-bottom: 0;
}
.detail-item-wrap {
    font-size: 0;
}
.detail-item {
    width: 33.33333%;
    font-size: 0;
    display: inline-block;
    line-height: 14px;
    height: 14px;
    margin-bottom: 20px;
    .label {
        display: inline-block;
        width: 112px;
        text-align: right;
        color: #666;
        font-size: 14px;
        vertical-align: middle;
    }
    .text {
        display: inline-block;
        font-size: 14px;
        color: #333;
        padding-left: 20px;
        width: 180px;
        vertical-align: middle;
    }
}
.detail-receipt {
    display: flex;
    align-items: center;
    margin-bottom: 0px;
    .add-receipt {
        margin-left: 20px;
        display: inline-block;
        width: 40px;
        height: 20px;
        border-radius: 4px;
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        color:  $color-primary;
        border:  1px solid $color-primary;
        cursor: pointer;
    }
    .text-number {
        display: inline-block;
        font-size: 14px;
        color: #333;
        padding-left: 20px;
        vertical-align: middle;
    }
}
</style>
<style lang="scss">
.group-dialog-detail {
    .el-dialog__body {
        display: flex;
        justify-content: center;
    }
    .el-form-item {
        margin-bottom: 24px;
        &.is-error {
            margin-bottom: 30px;
        }
    }
    .form-wrap {
        display: inline-block;
    }
    .dialog-btn-wrap {
        padding: 0 20px 24px 70px;
        text-align: left;
        .el-button {
            width: 96px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background-color: #f5f5f5;
            border-color: #dbdbdb;
            color: #666;
        }
    }
}
</style>
<script>
import { mapGetters } from 'vuex'
import { dateToString } from '@/utils/tools'
export default {
    name: 'hospitalList',
    data () {
        return {
            breadList: [{ label: '财务管理' }, { label: '订单管理', path: '/financial/orderList' }, { label: '订单详情' }],
            orderId: this.$route.params.orderId,
            activeName: this.$route.params.activeName,
            statusList: [],
            originList: [],
            typeList: [],
            orderDetail: {},
            loading: true,
            doctorWord: [
                {
                    DISPENSING: '处方医生'
                },
                {
                    VOLUNT: '接诊医生'
                },
                {
                    'VIDEO': '接诊医生'
                },
                {
                    'TEXT': '接诊医生'
                },
                {
                    'CONSULTATION': '发起医生'
                }
            ],
            groupForm: {
                invoiceNumber: ''
            },
            isEditShow: false,
            consultFrom: []
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    methods: {
        async getData () {
            this.loading = true
            const param = {
                orderId: this.orderId
            }
            const { results } = await this.$services.order.getOrderDetail(param)
            this.orderDetail = results
            this.loading = false
        },
        init () {
            this.originList = this.dictionary.USER_SOURCE
            this.statusList = this.dictionary.ORDER_STATUS
            this.typeList = this.dictionary.ORDER_TYPE
            this.getData()
            this.getOrginType()
        },
        editNumber () {
            this.groupForm.invoiceNumber = this.orderDetail.invoiceNumber || ''
            this.isEditShow = true
        },
        saveForm () {
            this.$refs['groupForm'].validate((valid) => {
                if (valid) {
                    this.submit()
                } else {
                    return false
                }
            })
        },
        async submit () {
            const param = {
                invoiceNumber: this.groupForm.invoiceNumber,
                orderId: this.orderId
            }
            const { results } = await this.$services.order.postOrderNumber(param)
            if (results) {
                if (this.orderDetail.invoiceNumber) {
                    this.$message.success('修改成功！')
                } else {
                    this.$message.success('添加成功！')
                }
            }
            this.isEditShow = false
            this.getData()
        },
        cancelForm () {
            this.groupForm.invoiceNumber = ''
            this.isEditShow = false
        },
        async getOrginType () {
            let param = {
                key: 'consult_from'
            }
            const { results } = await this.$services.order.getOrign(param)
            this.consultFrom = results || []
        }
    },
    filters: {
        getDate (value) {
            if (value) {
                const date = new Date(value)
                return dateToString(date, 'yyyy-MM-dd hh:mm')
            } else {
                return '暂无'
            }
        },
        getScoreTag (value, consultFrom) {
            if (value) {
                let reWord = '暂无'
                consultFrom.forEach(item => {
                    if (item.val === value) {
                        reWord = item.valText
                    }
                })
                return reWord
            } else {
                return '暂无'
            }
        }
    },
    mounted () {
        this.init()
    }
}
</script>
